import {observer} from 'mobx-react-lite'
import React, {Dispatch, SetStateAction} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Hub, StickerSettingsInBoard, Tag} from 'yougile-model'
import {ShowSumStickerSettingsContent} from '@components/sticker/my-stickers/board-stickers/sticker-settings/show-sum-sticker-settings-content'
import {SprintStickerSettingsContent} from '@components/sticker/my-stickers/board-stickers/sticker-settings/sprint-sticker-settings-content'
import {TitleStickerSettingsContent} from '@components/sticker/my-stickers/board-stickers/sticker-settings/title-sticker-settings-content'
import {useStickerEditorStore} from '@components/sticker/my-stickers/sticker-editor/sticker-editor-store'
import {useBoard} from '@containers/hooks'
import {Sticker} from '@extensions/sticker/sticker'
import {TwSettingsContent} from './containers'
import {DeadlineStickerSettingsContent} from './deadline/deadline-sticker-settings-content'
import {FilterByCurrentValueSettingsContent} from './filter-by-current-value-settings-content'
import {RequireStickerSettingsContent} from './require-sticker-settings-content'
import {StopwatchStickerSettingsContent} from './stopwatch/stopwatch-sticker-settings-content'
import {StringStickerSettingsContent} from './string-sticker-settings-content'
import {StickerSettingsState} from './types'
import {UserStickerSettingsContent} from './user-sticker-settings-content'

const TwTruncate = tw.span`
  inline-block
  truncate
  max-w-160
  align-bottom
`

export interface CommonProps {
  sticker: Tag
  board: Hub
  state: StickerSettingsState
  setState: Dispatch<SetStateAction<StickerSettingsInBoard>>
}

export const StickerSettingsContent = observer(() => {
  const [state, store] = useStickerEditorStore()
  const board = useBoard()
  const sticker = state.sticker
  const props: CommonProps = {
    sticker,
    board,
    state: state.stickerSettings,
    setState: store.updateStickerSettings
  }

  const isString = sticker.properties.stickerType === 'string'
  const isSprint = sticker.properties.stickerType === 'sprint'
  const isUser = sticker.properties.stickerType === 'user'
  const isStopwatch = sticker.properties.stickerType === 'stopwatch'
  const isDeadline = sticker.properties.stickerType === 'deadline'
  const isText = sticker.properties.stickerType === 'text'
  const isNumeric = sticker.properties.stickerType === 'numeric'

  const showRequiredStickerSettings =
    isString || isSprint || isUser || isText || isNumeric || isDeadline

  const stickerName = Sticker.getName(sticker)

  return (
    <div className="flex flex-col">
      <div className="py-8 text-sm-semibold text-primary">
        {Lang.msg.myStickers.stickerAutomationOnBoard1}{' '}
        <TwTruncate className="mr-4">
          {stickerName ? `${stickerName} ` : ''}
        </TwTruncate>
        {Lang.msg.myStickers.stickerAutomationOnBoard2}{' '}
        <TwTruncate>{board.title}</TwTruncate>
        {''}
      </div>
      <TwSettingsContent>
        {showRequiredStickerSettings && (
          <RequireStickerSettingsContent {...props} />
        )}
        {isSprint && <FilterByCurrentValueSettingsContent {...props} />}
        {isString && <StringStickerSettingsContent {...props} />}
        {isSprint && <SprintStickerSettingsContent {...props} />}
        {isUser && <UserStickerSettingsContent {...props} />}
        {isStopwatch && <StopwatchStickerSettingsContent {...props} />}
        {isDeadline && <DeadlineStickerSettingsContent {...props} />}
        {isNumeric && <ShowSumStickerSettingsContent {...props} />}
        {(isText || isNumeric) && <TitleStickerSettingsContent {...props} />}
      </TwSettingsContent>
    </div>
  )
})
